export const CREATE_PAYPAL_ORDER_MUTATION = `
mutation PaymentMutation {
  paypalCreateOrder {
    data {
      payPalOrderId
    }
    messages
  }
}`;
